import { Button, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  TagsInput,
  MemberMultiSelectDropdown,
  AllowedMembersAlert,
} from '../common';
import { getUserData } from '../../helpers';

const CreateProjectStep3 = ({
  prevStep,
  formProps,
  teamMembersList,
  isSubmitting,
}) => {
  // Filter inactive members
  const activeMembersList = teamMembersList.filter(function (item) {
    return item.status !== 'inactive';
  });

  const activeMembers = getUserData('activeMembers') || 0;
  const maxMembersAllowed = getUserData('maxMembersAllowed') || 0;

  return (
    <section>
      <div className="text-center">
        <h5 className="text-uppercase text-muted fw-light">Step 3 of 3</h5>
        <h2 className="mt-5">Finally, let’s invite the team.</h2>
        <p className="text-muted font-14 font-weight-normal mb-5">
          Add team Members from other Projects or <br />
          invite new Team Members via email.
        </p>
      </div>
      {teamMembersList.length > 0 && (
        <MemberMultiSelectDropdown
          id="selectInputRef"
          name="addExistingTeamMembers"
          labelText="Add existing Team Members"
          fromArray={activeMembersList}
          formProps={formProps}
        />
      )}
      {maxMembersAllowed - activeMembers > 0 && (
        <TagsInput
          id="tagInputRef"
          name="addNewTeamMembers"
          labelText="Invite a new Team Member"
          placeHolderText="Type email address and press enter"
          formProps={formProps}
        />
      )}
      <AllowedMembersAlert />
      <hr className="my-5" />
      <Row className="align-items-center">
        <Col className="col-auto">
          <Button className="btn btn-lg btn-white" type="button">
            Cancel
          </Button>
        </Col>
        <Col className="text-center">
          <h6 className="text-uppercase text-muted mb-0">Step 3 of 3</h6>
        </Col>
        <Col className="col-auto">
          <Button
            variant="secondary"
            size="lg"
            type="button"
            className="me-2"
            onClick={prevStep}
          >
            Back
          </Button>
          <Button
            variant="primary"
            size="lg"
            type="Submit"
            disabled={isSubmitting}
          >
            Create Project{' '}
            {isSubmitting && (
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </Col>
      </Row>
    </section>
  );
};

CreateProjectStep3.propTypes = {
  prevStep: PropTypes.func,
  teamMembersList: PropTypes.array,
  formProps: PropTypes.any,
  isSubmitting: PropTypes.bool,
};

export default CreateProjectStep3;
